import {useSafeChatState} from '@github-ui/copilot-chat/utils/CopilotChatContext'
import type {RepositoryVisibility} from '@github-ui/item-picker/RepositoryPicker'

export interface ShowCopilotFunctionalityInIssuesOptions {
  additionalConditions?: boolean[]
  repositoryVisibility: RepositoryVisibility
  userCanPushToRepo: boolean
  userSettingCopilotEnabled: boolean
}

export function useShouldShowCopilotFunctionalityInIssues({
  additionalConditions = [],
  repositoryVisibility,
  userCanPushToRepo,
  userSettingCopilotEnabled,
}: ShowCopilotFunctionalityInIssuesOptions): boolean {
  const chatState = useSafeChatState()

  if (chatState?.mode === 'immersive') return false
  if (!userSettingCopilotEnabled) return false
  if (repositoryVisibility === 'PUBLIC' && !userCanPushToRepo) return false

  return additionalConditions.every(condition => condition)
}
